'use strict'

/**
 * @classname ChangePublicationTo
 * @classdesc 「対象」を変更したとき関連するセレクトボックスの表示・非表示を切り替える
 */
export default class ChangePublicationTo {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.publication_to')
	 */
	constructor($e, controller) {
		console.log('ChangePublicationTo.constructor')
		this._$e = $e
		this._controller = controller
		this._$affiliationsWrap = $('.affiliations-wrap')
		this._$e.on('change', () => this.onChange())
		this.onChange(0)
	}

	/**
	 * changeのコールバック
	 *
	 * @memberof ChangePublicationTo
	 * @return {undefined}
	 */
	onChange(duration = 300) {
		console.log('ChangePublicationTo.onChange')
		if (this._$e.find('option:selected').data('show-affiliations')) {
			this._$affiliationsWrap
				.slideDown(duration)
				.find('.validate')
				.removeClass('ignore-validate');
		} else {
			this._$affiliationsWrap
				.slideUp(duration)
				.find('.validate')
				.removeClass('is-invalid')
				.addClass('ignore-validate')
				.closest('.form-group')
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
			$('.show_scout_age').val('').trigger('change');
			$('.target_member_master_council_id option').prop('selected', false).trigger('change');
		}
		if(duration !== 0) {
			$('#filter-n').click();
			$('.target_prefectures option').prop('selected', false).trigger('change');
		}
	}
}
